import request from "@/utils/request";

export default {
    // 增删改查
    createCustomer(data) {
        return request.post('/api/customers', data);
    },
    deleteCustomer(customerID) {
        return request.delete(`/api/customers/${customerID}`);
    },
    batchDeleteCustomers(customerIDs) {
        return request.delete(`/api/customers/batch`, {
            data: { customer_ids: customerIDs }
        });
    },
    updateCustomer(customerID, data) {
        return request.put(`/api/customers/${customerID}`, data);
    },
    inquireCustomer(customerID) {
        return request.get(`/api/customers/${customerID}`);
    },
    inquireCustomers(params) {
        return request.get('/api/customers', { params });
    },
    getCustomer(customerId) {
        return request.get(`/api/customers/${customerId}`);
    },
    
};